import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { SIGNOUT_URL } from "@libs/apiUrl";

const useAuthenticated = () => {
  const navigate = useNavigate();

  const isAuthenticated = localStorage.getItem("isLoggedIn") === "true";

  const logout = useCallback(async () => {
    try {
      await axios.post(SIGNOUT_URL, null, { withCredentials: true });
    } catch (e) {
      // Proceed with client-side cleanup even if server call fails
    }

    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("order-storage");
    localStorage.removeItem("accessToken");
    sessionStorage.clear();

    navigate("/");
  }, [navigate]);

  return { isAuthenticated, logout };
};

export default useAuthenticated;
